
import { Vue, Component, Prop } from 'vue-property-decorator'
import { openUrl } from '@/common/utils'
import { pcRankNo, pcRankNumber } from '@/common/config'
import { store } from '@/common/store'
import logger from '@plat-components/utils2/_esm5/logger'
@Component({
  name: 'RankList',
  components: {},
})
export default class RankList extends Vue {
  @Prop() rank: any
  @Prop() type: any
 
  get rankNoImg() {
    return pcRankNo[this.rank.id]
  } 
  get rankNumberImg() {
    return pcRankNumber[this.rank.id]
  }
  clickCover(link: string) {
    logger('list_video_click')
    logger(`video_${this.rank.bvid}_click`)
    if (this.type === 'day') {
      logger('dailylist_video_click')
    } else {
      logger('overalllist_video_click')
    }
    openUrl(link)
  }
  clickUpImage(mid: number) {
    openUrl(`https://space.bilibili.com/${mid}`)
  }
  changeStyle() {
    if (this.type === 'day') {
      if (this.rank.id % 2 === 0) {
        this.rank.active = true
        store.rankList.forEach((item: any) => {
          if (item.id !== this.rank.id && item.id % 2 === 0) {
            item.active = false
          }
        });
      } else {
        this.rank.active = true
        store.rankList.forEach((item: any) => {
          if (item.id !== this.rank.id && item.id %2 !== 0) {
            item.active = false
          }
        });
      }
    } else {
      if (this.rank.id % 2 === 0) {
        this.rank.active = true
        store.totalRankList.forEach((item: any) => {
          if (item.id !== this.rank.id && item.id % 2 === 0) {
            item.active = false
          }
        });
      } else {
        this.rank.active = true
        store.totalRankList.forEach((item: any) => {
          if (item.id !== this.rank.id && item.id %2 !== 0) {
            item.active = false
          }
        });
      }
    }
  }
}
